module.exports = __webpack_public_path__ + "static/media/Relative-Medium-Web.e9a0dc1c.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Relative-Medium-Web.eot
// module id = 747
// module chunks = 0